import { render, staticRenderFns } from "./ClientDownload.vue?vue&type=template&id=73354fcc&scoped=true"
import script from "./ClientDownload.vue?vue&type=script&lang=ts"
export * from "./ClientDownload.vue?vue&type=script&lang=ts"
import style0 from "./ClientDownload.vue?vue&type=style&index=0&id=73354fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73354fcc",
  null
  
)

export default component.exports